import ChiefRowModal from './chief-row-modal'

export default ChiefRowModal
